import { useTranslation } from 'react-i18next';
import ProjectCard from '../components/projectCard/ProjectCard';
import { projectsMeta } from './../helpers/projectsList';
import PageSEO from '../components/PageSEO';

const ProjectsPage = () => {
  const { t } = useTranslation('projects');
  const projectItems = t('items', { returnObjects: true }).map((item, i) => ({
    ...item,
    ...projectsMeta[i],
  }));

  return (
    <section className="section">
      <PageSEO
        title={`${t('title')} | PixelCraft`}
        description={t('seo.description')}
        path="/projects"
      />
      <div className="container--wide">
        <div className="proj-header">
          <h1 className="title-1">{t('title')}</h1>
          <p className="proj-header__count">
            <span className="proj-header__num">{projectItems.length}</span> {t('works')}
          </p>
        </div>
        <ul className="proj-grid">
          {projectItems.map((project, index) => (
            <ProjectCard
              key={index}
              index={index}
              title={project.title}
              img={project.img}
              imgBig={project.imgBig}
              skills={project.skills}
              description={project.description}
              websiteLink={project.websiteLink}
              gitHubLink={project.gitHubLink}
              isPublished={project.isPublished !== false}
            />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ProjectsPage;